<template>
  <div>
    <van-overlay
      :show="exchange_.show"
      :lock-scroll="false"
      z-index="3000"
    >
      <div
        class="exchange_box"
        @click.stop
      >
        <div
          class="exchange_ "
          :style="typeOfTeam==1?`height:310px;`:``"
        >
          <!-- 內容框 -->
          <div
            class="content pulse_ animated infinite_1"
            :style="`width:${exchange_.w1}px;`"
          >
            <div
              class="title theme_bg_color"
              v-text="`${typeOfTeam == 0 ? `發現${data.length}張優惠券` : `領取優惠券(共${data.length}張)`}`"
            ></div>
            <div
              class="img_ theme_bg_color"
              :style="`min-height:${exchange_.h2 + 40}px;`"
            >
              <!-- 彩帶 -->
              <div
                class="caidai slideInDown animated infinite_1 delay-05s"
                :style="`width:${exchange_.w3}px;`"
              >
                <img
                  class=" fadeIn animated infinite_1 delay-05s "
                  src="../assets/icon/coupon_caidai.png"
                />
              </div>
              <!-- 圖片 -->

              <!-- 金幣 -->
              <div class="gold pulse_1 animated infinite_1 delay-075s">
                <img src="../assets/icon/coupon_gold.png" />
              </div>

              <div
                class="img pulse_0 animated infinite_1 delay-075s"
                :style="`width:${exchange_.w2}px;`"
              >
                <div
                  class="item-box"
                  v-for="(item,index) in data_"
                  :key="index"
                  @click="item.select = !item.select"
                  v-if="(typeOfTeam==1 && index == 0) || typeOfTeam != 1"
                >
                  <div class="content-box">
                    <van-image
                      fit="cover"
                      class="img-box"
                      :style="`height:${exchange_.h2}px;`"
                      :src="item.imgUrl"
                    >
                      <template v-slot:loading>
                        <van-loading
                          type="spinner"
                          size="20"
                        />
                      </template>
                      <template v-slot:error>
                        <img
                          src="../assets/icon/default.png"
                          style="width:100%;height:100%;"
                        />
                      </template>
                    </van-image>
                    <div class="item2">
                      <div
                        v-text="item.brandName"
                        class="brandName"
                      ></div>
                      <div
                        v-text="item.couponNo"
                        class="couponNo"
                      ></div>
                      <div
                        class="time"
                        v-text="`${getDate(item.startTime)}到${getDate(item.endTime)}`"
                      ></div>
                    </div>
                    <div
                      class="check"
                      v-if="typeOfTeam==0"
                    >
                      <van-checkbox
                        v-model="item.select"
                        checked-color="#23bfa7"
                      ></van-checkbox>
                    </div>
                  </div>
                  <div class="radius"></div>
                  <div class="foot-box">
                    <div
                      class="rules"
                      v-text="item.remark"
                    ></div>
                    <van-icon
                      name="arrow-down"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="radius theme_bg_color"></div>
            <van-button
              class="ex_btn theme_bg_color theme_border_color"
              type="primary"
              block
              @click="hideClick"
            >{{lang_['Receive']}}</van-button>
            <div class="ex_bottom"></div>
          </div>

        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import util from "@/js/util";
import { updateCodeIsRead } from "@/js/api";
export default {
  name: 'couponExchangeSuccess',
  data () {
    return {
      lang_: {
        "Please enter the promo code to redeem": "請輸入優惠碼兌換",
        "exchange": "兌換",
        "be usable": "可使用",
        "unavailable": "不可使用",
        "Rules of use": "使用規則",
        "off": "折",
        "to": "到",
        "Discount": "優惠",
        "Over ONE available": "滿ONE可用",
        "cap_Confirm": "確定",
        "Successful redeem a coupon!": "恭喜兌換成功一張優惠券",
        "Receive": "領取",
        "Coupon saved in your wallet": "已自動存至優惠券"

      },
      exchange_: {
        show: false,
        imgUrl: "",
        // 內容框 寬
        w1: 0,
        // 圖片框 寬 高
        w2: 0,
        h2: 0,
        // 彩帶寬
        w3: 0,
      },
      data_: [],
      userInfo: {}
    }
  },
  mounted () {
    this.initWindow();
    let userinfoStr = util.userInfo.get(this);
    let userinfo = JSON.parse(userinfoStr);
    this.userInfo = userinfo
  },
  created () { },
  methods: {
    initWindow () {
      let J = util.getWindowInner(),
        w = J.w, h = J.h;
      this.exchange_.w1 = w - 40;
      this.exchange_.w2 = (w - 80);
      this.exchange_.h2 = (w - 80) * 0.4 / 1.75;
      this.exchange_.w3 = w - 90;
    },
    initLang () {

    },
    hideClick () {
      // 更改父級
      this.$parent.change.show = false
      this.exchange_.show = false;
      let ids = [];
      let data = this.data_;
      if (this.typeOfTeam == 1 || this.typeOfTeam == 2) {
        for (let i in data) {
          ids.push(data[i].id);
        }
        updateCodeIsRead({
          brandId: util.getBrandId(this),
          invitedMemberId: this.userInfo.memberId,
          isRead: 1,
          ids: ids.join(',')
        })
      } else {
        for (let i in data) {
          if (data[i].select)
            ids.push(data[i].id);
        }
        this.$parent.changeClick(ids.join(','));
      }
    },
    getDate (t) {
      return util.getDate(t);
    }
  },
  props: {
    show: { default: false },
    img: { default: '' },
    data: {
      default: []
    },
    // 0 啥也不是, 1 是独特的 2 是多個的
    typeOfTeam: {
      default: () => {
        return 0;
      }
    }
  },
  watch: {
    show () {
      this.exchange_.show = this.show;
    },
    img () {
      this.exchange_.imgUrl = this.img;
    },
    data () {
      let data = this.data;
      for (let i in data) {
        data[i].select = false;
      }
      this.data_ = JSON.parse(JSON.stringify(data));
    }
  }
}
</script>
<style lang="less" scoped>
/* 兌換優惠券彈窗 */
.exchange_box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.exchange_ {
  width: 100%;
  max-height: 80%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    border-radius: 8px;
    padding: 0;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      width: 100%;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      border-radius: 5px 5px 0 0;
    }
    .img_ {
      width: 100%;
      flex-grow: 1;
      padding: 0 20px;
      position: relative;
    }
    .radius {
      background-image: url("../assets/icon/coupon_b.png");
      height: 9px;
      width: 100%;
    }
  }
}
.ex_btn {
  width: calc(100% - 35px);
  font-size: 20px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  border-radius: 5px;
  margin-top: 20px;
}
.ex_bottom {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  margin: 12px 0;
}

.exchange_ .caidai {
  position: absolute;
  top: 0;
  left: -10px;
  width: calc(100% + 20px) !important;
}
.exchange_ .caidai img {
  width: 100%;
}
.exchange_ .img {
  // position: absolute;
  z-index: 33;
  height: 100%;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.exchange_ .gold {
  position: absolute;
  left: -10px;
  width: calc(100% + 20px);
  top: 0;
}
.exchange_ .gold img {
  width: 100%;
}

/* 動畫 */
.animated.infinite_1 {
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes pulse_ {
  from {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0, 0, 0);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse_ {
  from {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0, 0, 0);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.pulse_ {
  -webkit-animation-name: pulse_;
  animation-name: pulse_;
}
.animated.delay-05s {
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.animated.delay-075s {
  -webkit-animation-delay: 0.75s;
  animation-delay: 0.75s;
}
@-webkit-keyframes slideInDown {
  from {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideInDown {
  from {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.slideInDown {
  -webkit-animation-name: slideInDown;
  animation-name: slideInDown;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

@-webkit-keyframes pulse_0 {
  from {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0, 0, 0);
  }

  /* 50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05);
	} */
  40% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse_0 {
  from {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0, 0, 0);
  }

  /* 50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05);
	} */
  40% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
.pulse_0 {
  -webkit-animation-name: pulse_0;
  animation-name: pulse_0;
}

@-webkit-keyframes pulse_1 {
  from {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0, 0, 0);
  }

  40% {
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  60% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  70% {
    -webkit-transform: scale3d(0.95, 0.95, 0.95);
    transform: scale3d(0.95, 0.95, 0.95);
  }

  80% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  90% {
    -webkit-transform: scale3d(0.95, 0.95, 0.95);
    transform: scale3d(0.95, 0.95, 0.95);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse_1 {
  from {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0, 0, 0);
  }

  40% {
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  60% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  70% {
    -webkit-transform: scale3d(0.95, 0.95, 0.95);
    transform: scale3d(0.95, 0.95, 0.95);
  }

  80% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  90% {
    -webkit-transform: scale3d(0.95, 0.95, 0.95);
    transform: scale3d(0.95, 0.95, 0.95);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.pulse_1 {
  -webkit-animation-name: pulse_1;
  animation-name: pulse_1;
}

.theme_bg_color {
  background-color: #23bfa7;
}

.item-box {
  margin: 0 0 10px 0;
  .content-box {
    display: flex;
    background-color: #fff;
    border-radius: 5px 5px 0 0;
    padding: 5px 0;
    .img-box {
      width: 40%;
    }
    .item2 {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      flex-grow: 1;
      margin-left: 10px;
      .brandName {
        font-size: 16px;
        color: #3c3c3c;
      }
      .couponNo {
        color: #23bfa7;
        font-size: 14px;
      }
      .time {
        font-size: 12px;
        font-weight: 400;
        color: #3c3c3c;
      }
    }
    .check {
      width: 25px;
      display: flex;
      align-content: center;
      justify-content: center;
      margin-right: 10px;
    }
  }
  .radius {
    background-image: url("../assets/icon/coupon_radiu_min.png");
    height: 6px;
    background-size: 12px;
    background-repeat: repeat;
    background-color: #fff;
  }
  .foot-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #e8e8e8;
    padding: 5px 10px;
    border-radius: 0 0 5px 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/couponExchangeSuccess.vue